import React, { useState } from "react";
import "../../pages/doctor-console/DoctorConsole.scss";
import {
  Modal,
  Box,
  Typography,
  Button as muiButton,
  IconButton,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { Row, Col } from "../../components/RowCol";
import { Table, Button } from "react-bootstrap";
import { Icon, TableHead } from "@mui/material";
import HiTypeHeader from "../../pages/doctor-console/Utils/HiTypeHeader";
import { separateCamelCase } from "../../pages/doctor-console/Utils/UtilsFunctions";
import { DoctorconsoleGrid } from "../../pages/doctor-console/StyledComponents";

const RecordArtifact = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const recordArtifactData = props.recordArtifactData;

  const handleDownloadAttachment = (attach) => {
    if (!attach) return;
    const { content_type, data, id } = attach;
    try {
      const byteCharacters = atob(data);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }
      const ext = content_type === "application/pdf" ? ".pdf"
        : content_type === "image/png" ? ".png" : ".jpg";
      const blob = new Blob([byteArray], { type: content_type });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = (id || "attachment") + ext;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Download failed:", e);
    }
  };

  const handlePrintAttachment = (attach) => {
    if (!attach) return;
    const { content_type, data, id } = attach;
    try {
      if (content_type === "application/pdf") {
        const byteCharacters = atob(data);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        const printWindow = window.open(blobUrl);
        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print();
            URL.revokeObjectURL(blobUrl);
          };
        }
      } else {
        const url = `data:${content_type};base64,${data}`;
        const printWindow = window.open("", "_blank");
        if (printWindow) {
          printWindow.document.write(
            "<html><head><title>" + (id || "attachment") +
            '</title></head><body style="margin:0;display:flex;justify-content:center;align-items:center;min-height:100vh">' +
            '<img src="' + url + '" style="max-width:100%;max-height:100vh;" onload="window.print();" />' +
            "</body></html>"
          );
          printWindow.document.close();
        }
      }
    } catch (e) {
      console.error("Print failed:", e);
    }
  };

  const viewAttachment = (attach) => {
    // console.log(attachment);
    let attachment = attach;
    console.log("Attachment in record artifact", attach);
    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (attachment.content_type === "application/pdf") {
      const url = `data:application/pdf;base64,${attachment.data}#toolbar=0`;
      modalContent = (
        <iframe width="100%" height="100%" src={url} title={attach.id}></iframe>
      );
    } else if (
      attachment.content_type === "image/jpeg" ||
      attachment.content_type === "image/jpg" ||
      attachment.content_type === "image/png"
    ) {
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt={attach.id} title={attach.id} />
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setCurrentAttachment(attachment);
    setModalContent(modalContent);
    setShowModal(true);
  };
  const formatDate = (visitDatetime) => {
    const formattedDate = new Date(visitDatetime);

    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = String(formattedDate.getFullYear()).slice(-2); // Extract the last two digits of the year

    let hours = formattedDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

    console.log(formattedDateTime);
    return formattedDateTime;
  };
  const closeModal = () => {
    setShowModal(false);
    setModalContent(null);
    setCurrentAttachment(null);
  };

  // console.log(state);
  return (
    <>
      <DoctorconsoleGrid>
        {recordArtifactData !== undefined && recordArtifactData !== null ? (
          <>
            <HiTypeHeader
              date={recordArtifactData.Date}
              name={"Health Document Record"}
              encounter={recordArtifactData.Encounter}
              organizationDetails={recordArtifactData.Organization}
              practitionerDetails={recordArtifactData.Practitioner}
            />
            {Object.keys(recordArtifactData).map(
              (categoryKey) =>
                ![
                  "Encounter",
                  "Date",
                  "Organization",
                  "Practitioner",
                  "Patient",
                ].some(
                  (substring) =>
                    substring === categoryKey.match(/\(([^)]+)\)/)?.[1] ||
                    substring == categoryKey // Extract and check in the same line
                ) && (
                  <Accordion className="innermost-accordion" defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      className="innermost-accordion-summary"
                    >
                      <Typography
                        sx={{ color: "white" }}
                        className="accordion-section-title"
                      >
                        {categoryKey}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Row
                        style={{
                          marginTop: "30px",
                          // backgroundImage:
                          //   "url('../../assets/images/backgrounds/2.jpg')",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <Col
                          area="span 12"
                          style={{ border: "2px solid #76787a" }}
                        >
                          {categoryKey.includes("DocumentReference") ? (
                            <div
                              style={{
                                marginTop: "20px",
                                fontWeight: "bold",
                                marginBottom: "50px",
                                fontSize: "16px",
                              }}
                            >
                              Attachments :{" "}
                              {recordArtifactData[categoryKey].length > 0
                                ? recordArtifactData[categoryKey].map(
                                    (attachment, attIdx) => (
                                      <span
                                        key={attIdx}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "4px",
                                          marginRight: "12px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "#007bff",
                                            color: "#fff",
                                            border: "none",
                                            padding: "5px 10px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            viewAttachment(
                                              attachment?.content?.[0]
                                            )
                                          }
                                        >
                                          <i className="fas fa-file"></i>
                                        </button>
                                        <Tooltip title="Download">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleDownloadAttachment(
                                                attachment?.content?.[0]
                                              )
                                            }
                                            sx={{
                                              color: "#fff",
                                              backgroundColor: "#125386",
                                              "&:hover": {
                                                backgroundColor: "#0e4270",
                                              },
                                              width: 30,
                                              height: 30,
                                            }}
                                          >
                                            <DownloadOutlinedIcon
                                              sx={{ fontSize: 18 }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Print">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handlePrintAttachment(
                                                attachment?.content?.[0]
                                              )
                                            }
                                            sx={{
                                              color: "#fff",
                                              backgroundColor: "#125386",
                                              "&:hover": {
                                                backgroundColor: "#0e4270",
                                              },
                                              width: 30,
                                              height: 30,
                                            }}
                                          >
                                            <PrintOutlinedIcon
                                              sx={{ fontSize: 18 }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </span>
                                    )
                                  )
                                : "No attachments found!"}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                    </AccordionDetails>
                  </Accordion>
                )
            )}
          </>
        ) : (
          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              backgroundColor: "#3AC8BA",
              fontWeight: "bold",
              fontSize: "25px",
            }}
          >
            No Discharge Summary found!
          </div>
        )}
      </DoctorconsoleGrid>

      <Modal open={showModal} onClose={closeModal}>
        <Box className="modal-box">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "4px",
              padding: "8px 12px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            {currentAttachment && (
              <>
                <Tooltip title="Download">
                  <IconButton
                    onClick={() => handleDownloadAttachment(currentAttachment)}
                    sx={{
                      color: "#125386",
                      backgroundColor: "#e3f2fd",
                      "&:hover": { backgroundColor: "#bbdefb" },
                    }}
                  >
                    <DownloadOutlinedIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Print">
                  <IconButton
                    onClick={() => handlePrintAttachment(currentAttachment)}
                    sx={{
                      color: "#125386",
                      backgroundColor: "#e3f2fd",
                      "&:hover": { backgroundColor: "#bbdefb" },
                    }}
                  >
                    <PrintOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
            <IconButton onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>
          <div style={{ flex: 1 }}>{modalContent}</div>
        </Box>
      </Modal>
    </>
  );
};

export default RecordArtifact;
